import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Center, Flex, Heading, Spinner, Text } from '@chakra-ui/react';
import { MdArrowBack, MdEdit } from 'react-icons/md';

import { UserPill } from 'components/core/UserPill';

import SiteForm from 'components/modules/SiteForm';

import { SiteDetailsViewProps } from './SiteDetails.props';

const SiteDetailsView: FC<SiteDetailsViewProps> = ({
  site,
  siteId,
  siteName,
  isLoading,
  onSubmit,
  isLoadingSite,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();

  return (
    <Flex flex={1} direction="column">
      <Flex p="20px 40px" shadow="lg" justify="space-between">
        <Flex gap="20px" align="center">
          <button onClick={() => navigate(-1)}>
            <MdArrowBack size="26px" />
          </button>
          <Heading fontSize="24px" fontWeight="600">
            {siteName || site?.name} details
          </Heading>
        </Flex>

        <Flex gap="20px">
          {isEditing ? (
            <Button w="150px" onClick={() => setIsEditing(false)}>
              Cancel
            </Button>
          ) : (
            <>
              {/* <Button
                w="150px"
                colorScheme="red"
                bg="red.500"
                _hover={{ bg: 'red.600' }}
                _active={{ bg: 'red.700' }}
                leftIcon={<MdDelete size="20px" />}>
                Delete
              </Button> */}
              <Button
                w="150px"
                leftIcon={<MdEdit size="20px" />}
                onClick={() => setIsEditing(true)}>
                Edit
              </Button>
            </>
          )}
          <UserPill />
        </Flex>
      </Flex>

      {isLoadingSite ? (
        <Center flex={1}>
          <Spinner size="xl" />
        </Center>
      ) : site ? (
        <Flex
          flex={1}
          direction="column"
          p="40px"
          maxW="1400px"
          alignSelf="center"
          w="100%">
          <SiteForm
            site={site}
            siteId={siteId}
            isLoading={isLoading}
            isReadOnly={!isEditing}
            onSubmit={onSubmit}
            onEditForm={() => setIsEditing(true)}
          />
        </Flex>
      ) : null}
    </Flex>
  );
};

export default SiteDetailsView;
